var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-12,.cls-7,.cls-8{fill:#51bfff;}.cls-1{opacity:0.1;}.cls-2{fill:#f9f9f9;}.cls-2,.cls-3,.cls-4{stroke:#52bfff;}.cls-2,.cls-3,.cls-4,.cls-6{stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-3,.cls-6{fill:none;}.cls-4{fill:#fff;}.cls-5{opacity:0.4;}.cls-6{stroke:#51bfff;}.cls-7{opacity:0.5;}.cls-11,.cls-8{opacity:0.2;}.cls-9{fill:#52bfff;}.cls-10{opacity:0.3;}.cls-13{opacity:0.6;}.cls-14{opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 141,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.84,39l-2.13-5.83a2.41,2.41,0,0,0-2.05-1.67L202,30a2.42,2.42,0,0,0-2.66,2.16l-3.7,35.52a2.41,2.41,0,0,0,2.16,2.65l50,5.21a2.42,2.42,0,0,0,2.66-2.16l2.82-27.09a2.42,2.42,0,0,0-2.16-2.66l-28.17-2.93A2.43,2.43,0,0,1,220.84,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.56,34.47l-1.31-6.06a2.43,2.43,0,0,0-1.81-1.93L216.1,23a2.41,2.41,0,0,0-2.92,1.78l-8.49,34.69a2.42,2.42,0,0,0,1.78,2.92l48.8,11.94a2.42,2.42,0,0,0,2.92-1.78l6.47-26.46a2.4,2.4,0,0,0-1.77-2.92l-27.52-6.73A2.44,2.44,0,0,1,233.56,34.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 174.18,
    x2: 281,
    y2: 174.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 13.44,
    y: 34.78,
    width: 52.33,
    height: 68.03,
    rx: 5.23,
    transform: "translate(-22.73 19.65) rotate(-21.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.83,29.76l32.24-8.1a5.25,5.25,0,0,1,6.35,3.8l14,55.83a5.25,5.25,0,0,1-3.8,6.35L37,97.84A5.25,5.25,0,0,1,30.69,94l-12-47.94A5.19,5.19,0,0,1,19.32,42l6.37-10A5.22,5.22,0,0,1,28.83,29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.94,33.27l1.46,5.8a4.5,4.5,0,0,1-3.26,5.45L23.34,46"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 38.58,
    y1: 51.59,
    x2: 63.96,
    y2: 45.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 29.7,
    y1: 53.82,
    x2: 32.23,
    y2: 53.18
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 40.49,
    y1: 59.2,
    x2: 65.87,
    y2: 52.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 31.61,
    y1: 61.43,
    x2: 34.15,
    y2: 60.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 42.4,
    y1: 66.82,
    x2: 67.78,
    y2: 60.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 33.52,
    y1: 69.05,
    x2: 36.06,
    y2: 68.41
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 44.32,
    y1: 74.43,
    x2: 69.69,
    y2: 68.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 35.43,
    y1: 76.66,
    x2: 37.97,
    y2: 76.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 46.23,
    y1: 82.04,
    x2: 71.61,
    y2: 75.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 37.35,
    y1: 84.27,
    x2: 39.88,
    y2: 83.64
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 29.11,
    cy: 135.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 125.61,
    cy: 24.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 251.61,
    cy: 95.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 148.61,
    cy: 32.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 32.61,
    cy: 153.5,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56,
    y: 43.5,
    width: 170,
    height: 113.33,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.72,
    y: 48.22,
    width: 160.56,
    height: 90.67,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.92,
    y: 168.17,
    width: 48.17,
    height: 5.67,
    rx: 2.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.67,
    y: 156.83,
    width: 22.67,
    height: 11.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.82,
    y1: 62.39,
    x2: 220.43,
    y2: 62.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 68.85,
    cy: 55.78,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 76.4,
    cy: 55.78,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 141,
    cy: 147.39,
    r: 2.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 83.96,
    cy: 55.78,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 88.68,
    cy: 157.78,
    r: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.62,102.71v-5H109V95l7.28-18.68h3.88l-7.52,18.28h9l0-8h3.48v8h3.2v3.12h-3.2v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141,103.11a12.17,12.17,0,0,1-4.12-.64,7,7,0,0,1-3.06-2.16,10.19,10.19,0,0,1-1.9-4.08,26.59,26.59,0,0,1-.64-6.36,31,31,0,0,1,.62-6.72,10.79,10.79,0,0,1,1.88-4.32,7,7,0,0,1,3.06-2.28,11.67,11.67,0,0,1,4.12-.68,11.93,11.93,0,0,1,4.2.68,6.68,6.68,0,0,1,3,2.28,11.5,11.5,0,0,1,1.86,4.3,29.67,29.67,0,0,1,.64,6.74,21.86,21.86,0,0,1-1.16,7.92,7.83,7.83,0,0,1-3.3,4.1A10.34,10.34,0,0,1,141,103.11Zm0-3.08a6.88,6.88,0,0,0,2.62-.46,4.16,4.16,0,0,0,1.9-1.6,8.43,8.43,0,0,0,1.14-3.12,27.41,27.41,0,0,0,.38-5,32.56,32.56,0,0,0-.36-5.34,9.9,9.9,0,0,0-1.1-3.34,4.07,4.07,0,0,0-1.88-1.74,7.54,7.54,0,0,0-5.4,0,4.27,4.27,0,0,0-1.9,1.72,9.42,9.42,0,0,0-1.14,3.34,31.82,31.82,0,0,0-.38,5.4,25.53,25.53,0,0,0,.4,5,8.22,8.22,0,0,0,1.2,3.1,4.38,4.38,0,0,0,1.92,1.58A6.74,6.74,0,0,0,141,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M166.34,102.71v-5h-12.6V95L161,76.31h3.88l-7.52,18.28h9l0-8h3.48v8h3.2v3.12h-3.2v5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 242.61,
    cy: 125.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 269.61,
    cy: 102.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 155.61,
    cy: 13.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 13.61,
    cy: 159.5,
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 9.94,
    y: 120,
    width: 1.33,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 9.94,
    y: 120,
    width: 1.33,
    height: 6,
    transform: "translate(133.61 112.39) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 42.94,
    y: 167.5,
    width: 1.33,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 42.94,
    y: 167.5,
    width: 1.33,
    height: 6,
    transform: "translate(214.11 126.89) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 186.94,
    y: 20.5,
    width: 1.33,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 186.94,
    y: 20.5,
    width: 1.33,
    height: 6,
    transform: "translate(211.11 -164.11) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 254.94,
    y: 109.5,
    width: 1.33,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 254.94,
    y: 109.5,
    width: 1.33,
    height: 6,
    transform: "translate(368.11 -143.11) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 197.94,
    y: 169.5,
    width: 1.33,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 197.94,
    y: 169.5,
    width: 1.33,
    height: 6,
    transform: "translate(371.11 -26.11) rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32.34,
    y: 136,
    width: 42,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.08,
    y: 126.18,
    width: 52.52,
    height: 12.61,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.34,
    y1: 129.86,
    x2: 32.34,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.59,
    y1: 129.86,
    x2: 37.59,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.84,
    y1: 129.86,
    x2: 42.84,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.09,
    y1: 129.86,
    x2: 48.09,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.34,
    y1: 129.86,
    x2: 53.34,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.6,
    y1: 129.86,
    x2: 58.6,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 71.73,
    cy: 132.48,
    r: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.08,
    y: 144.04,
    width: 52.52,
    height: 12.61,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.34,
    y1: 147.71,
    x2: 32.34,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.59,
    y1: 147.71,
    x2: 37.59,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.84,
    y1: 147.71,
    x2: 42.84,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.09,
    y1: 147.71,
    x2: 48.09,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.34,
    y1: 147.71,
    x2: 53.34,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.6,
    y1: 147.71,
    x2: 58.6,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 71.73,
    cy: 150.34,
    r: 2.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.08,
    y: 161.89,
    width: 52.52,
    height: 12.61,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.34,
    y1: 165.57,
    x2: 32.34,
    y2: 170.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.59,
    y1: 165.57,
    x2: 37.59,
    y2: 170.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.84,
    y1: 165.57,
    x2: 42.84,
    y2: 170.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.09,
    y1: 165.57,
    x2: 48.09,
    y2: 170.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.34,
    y1: 165.57,
    x2: 53.34,
    y2: 170.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.6,
    y1: 165.57,
    x2: 58.6,
    y2: 170.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 71.73,
    cy: 168.2,
    r: 2.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 218.59,
    cy: 143.49,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.59,135.66a11.65,11.65,0,0,1,.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.47,133.37a14.31,14.31,0,0,1,19.66-.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 231.32,
    y1: 156.22,
    x2: 233.44,
    y2: 158.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.37,
    y: 156.26,
    width: 7,
    height: 19,
    rx: 3.5,
    transform: "translate(-46.66 218.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 235.92,
    y1: 165.76,
    x2: 240.87,
    y2: 160.81
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M241.91,30.31,243.8,28l2.33,1.89-1.89,2.33ZM245,27.05c0-.15.1-.36.2-.63a3,3,0,0,1,.44-.74,2,2,0,0,1,.77-.6,3.1,3.1,0,0,1,1-.27,12.23,12.23,0,0,1,1.45-.07,11.83,11.83,0,0,0,1.35-.06,2.1,2.1,0,0,0,.8-.24,2.87,2.87,0,0,0,.61-.57,1.39,1.39,0,0,0,.35-1.28,3.13,3.13,0,0,0-1.1-1.36q-.37-.3-.87-.63c-.34-.21-.68-.41-1-.59l-.9-.49,1.25-1.74c.32.13.69.3,1.12.5a13.63,13.63,0,0,1,1.3.69,9.19,9.19,0,0,1,1.15.79,5.52,5.52,0,0,1,2.1,2.83,3.55,3.55,0,0,1-1,3,6.72,6.72,0,0,1-1.16,1.17,2.78,2.78,0,0,1-1.17.5,9.43,9.43,0,0,1-1.65.11,11.11,11.11,0,0,0-1.88.11,1.71,1.71,0,0,0-1,.53l-.39.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.64,27.8,70.38,12.7,75.3,9.83l8.61,15.49ZM84.08,36l-2.92-5,4.75-2.77,2.92,5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M215.15,152.12l.8-3.38,3.19.75-.8,3.38Zm1.43-5.36,2.2-10.34,3.3.77-2.63,10.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M13.77,108.71a3.58,3.58,0,0,1-.43-.33,2.2,2.2,0,0,1-.47-.53,1.65,1.65,0,0,1-.26-.76,2.58,2.58,0,0,1,.07-.89,9.53,9.53,0,0,1,.33-1.14c.15-.44.25-.8.31-1.06a1.76,1.76,0,0,0,0-.68,2.11,2.11,0,0,0-.28-.63,1.13,1.13,0,0,0-.9-.61,2.53,2.53,0,0,0-1.35.49,7.87,7.87,0,0,0-.72.52c-.25.2-.5.41-.73.63s-.44.4-.61.57l-1-1.43.69-.74a11.73,11.73,0,0,1,.88-.83,7.94,7.94,0,0,1,.91-.68A4.55,4.55,0,0,1,13,99.72,2.92,2.92,0,0,1,15,101.3a5.46,5.46,0,0,1,.61,1.21,2.43,2.43,0,0,1,.08,1,9.72,9.72,0,0,1-.35,1.31,7.32,7.32,0,0,0-.41,1.49,1.36,1.36,0,0,0,.14.91l.28.44ZM15.49,112l-1.32-2.08,2.09-1.31,1.31,2.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M110.08,123.67v-12.3h8.17v2.07h-5.69v3h4.61v2h-4.61v3.14h5.69v2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M121.79,123.67v-12.3h4.81a7.15,7.15,0,0,1,2.48.38,2.77,2.77,0,0,1,1.49,1.26,4.93,4.93,0,0,1,.49,2.4,4.79,4.79,0,0,1-.47,2.24,3,3,0,0,1-1.45,1.34l1.92,4.68h-2.61l-1.62-4.13h-2.55v4.13Zm2.49-6.16h2.37a2.06,2.06,0,0,0,1.1-.26,1.42,1.42,0,0,0,.6-.74,3.08,3.08,0,0,0,.18-1.09,2.17,2.17,0,0,0-.47-1.51,1.92,1.92,0,0,0-1.46-.5h-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M134.68,123.67v-12.3h4.81a7,7,0,0,1,2.47.38,2.76,2.76,0,0,1,1.5,1.26,4.93,4.93,0,0,1,.49,2.4,4.78,4.78,0,0,1-.48,2.24A2.94,2.94,0,0,1,142,119l1.92,4.68h-2.61l-1.62-4.13h-2.55v4.13Zm2.49-6.16h2.37a2.08,2.08,0,0,0,1.1-.26,1.41,1.41,0,0,0,.59-.74,3.08,3.08,0,0,0,.18-1.09,2.17,2.17,0,0,0-.46-1.51,1.94,1.94,0,0,0-1.46-.5h-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M152.41,123.87a6,6,0,0,1-3.1-.7,3.81,3.81,0,0,1-1.64-2.09,10.69,10.69,0,0,1-.5-3.51,10.91,10.91,0,0,1,.5-3.55,3.93,3.93,0,0,1,1.64-2.14,5.76,5.76,0,0,1,3.1-.72,5.82,5.82,0,0,1,3.11.72,4,4,0,0,1,1.64,2.14,13.07,13.07,0,0,1,0,7.09,3.76,3.76,0,0,1-1.64,2.08A6.13,6.13,0,0,1,152.41,123.87Zm0-2.09a2.78,2.78,0,0,0,1.72-.46,2.32,2.32,0,0,0,.78-1.41,11.08,11.08,0,0,0,.2-2.34,12.11,12.11,0,0,0-.2-2.37,2.54,2.54,0,0,0-5,0,11.24,11.24,0,0,0-.22,2.37,10.87,10.87,0,0,0,.21,2.32,2.45,2.45,0,0,0,.79,1.41A2.67,2.67,0,0,0,152.41,121.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M161.32,123.67v-12.3h4.81a7,7,0,0,1,2.47.38,2.76,2.76,0,0,1,1.5,1.26,4.93,4.93,0,0,1,.49,2.4,4.78,4.78,0,0,1-.48,2.24,2.94,2.94,0,0,1-1.44,1.34l1.92,4.68H168l-1.62-4.13h-2.55v4.13Zm2.49-6.16h2.37a2.08,2.08,0,0,0,1.1-.26,1.41,1.41,0,0,0,.59-.74,3.08,3.08,0,0,0,.18-1.09,2.17,2.17,0,0,0-.46-1.51,1.94,1.94,0,0,0-1.46-.5h-2.32Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg404);
export default __webpack_public_path__ + "static/media/img_404.8124e0365949864d32e7ac90310c6430.svg";
export { ForwardRef as ReactComponent };